import {AppFunction} from "../misc/types";
import View from "../framework/view";
import Server, {PingResult} from "../server";
import template from "../../pugc/about";
import jQuery from "jquery";
import {toCanvas} from "qrcode";

export class AboutFunction extends AppFunction {

    readonly v : View;

    constructor(admin: boolean) {
        super();
        this.v = new AboutView(admin);
    }

    view() {
        return this.v;
    }
    url() {
        return "/about";
    }

    offlineEnabled() {
        return true;
    }
}

class AboutView extends View {

    static classname = "about-view";

    private serverVersion? : PingResult;
    private clientVersion : PingResult;

    private readonly admin : boolean;

    private readonly server = Server.instance();

    private shortUrl? : string;

    constructor(admin: boolean) {
        super(AboutView.classname);

        this.admin = admin;

        // @ts-ignore
        this.clientVersion = (window && window.wrb_git) || {
            "version": "dev",
            "branch": "dev"
        }

        Server.instance().ping("about").then((p) => {
            this.serverVersion = p;
            this.update();
        })

        this.server.getShortBaseUrl().then((url) => {
            this.shortUrl = url;
            this.update();
        });
    }

    protected render0(): JQuery<HTMLElement> {

        const trunc = function(s?: string) {
            return s ? s.substring(0, 8) : "";
        }

        const branch = function(b?: string) {
            return b && b != "master" ? b : "";
        }

        const data = {
            baseUrl: this.server.getBaseUrl(),
            shortUrl: this.shortUrl,
            trunc: trunc,
            branch: branch,
            clientVersion: this.clientVersion,
            serverVersion: this.serverVersion,
            admin: this.admin,
        };

        const out = this.pug(template, data);

        if (this.shortUrl) {
            this.afterUpdate(() => {
                const width = this.elt().find(".qrcode").width();
                const canvases = this.elt().find("canvas");
                canvases.each((idx, c) => {
                    const canvas = jQuery(c);
                    const url = canvas.data("url");
                    console.log("canvas width ", width);
                    toCanvas(c, url, {
                        errorCorrectionLevel: "high",
                        width: width
                    }, (err) => console.log(err))
                });
            });
        }

        return out;
    }

}

